import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { AppMetaData, AppMetaDataLookups, FlightSchoolOrganizationEntity, UserTypeAllItems } from '../../../../meta-data/app-meta-data.service';
import { DwButtonConfig, DwModalResult, DwButtonCommand, DwModalHandler, DwModalConfig, DwOrmDataServiceToken, DwOrmDataService } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { AdminUserProperties } from '../../models/admin-user-properties.model';
import { PilexosUser } from '../../models/pilexos-user.model';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-user-type-selection-modal',
  templateUrl: './user-type-selection-modal.component.html',
  styleUrls: ['./user-type-selection-modal.component.scss']
})
export class UserTypeSelectionModalComponent implements OnInit, DwModalHandler {
  userTypeLookupId = AppMetaDataLookups.UserTypeAllItems;
  flightSchoolOrganizationLookupId = AppMetaDataLookups.FlightSchoolOrganizationAllItems;
  adminUserTypeId: any;
  canSetUserType: boolean;

  flightSchoolOrganizationId: number;

  flightSchoolUserTypeId = UserTypeAllItems.FlightSchool;

  modalConfig: DwModalConfig<PilexosUser>;
  closeModal: EventEmitter<DwModalResult<any>>;
  ngOnDestroy?: () => void;

  constructor(@Inject(DwOrmDataServiceToken) private ormDataService: DwOrmDataService) {

  }

  ngOnInit(): void {
    const user = this.modalConfig.data;

    if (user == null) {
      console.error("UserTypeSelectionModalComponent: No user passed in modal data");

      return;
    }

    this.adminUserTypeId = user.UserTypeId;

    this.flightSchoolOrganizationId = user.flightSchoolOrganizationId;
  }

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult> {
    const modalResult = new DwModalResult<Partial<AdminUserProperties>>();

    modalResult.closeModal = true;
    modalResult.cancelled = false;
    modalResult.buttonCommand = buttonConfig.command;

    switch (buttonConfig.command) {
      case DwButtonCommand.saveAndClose:

        if (!this.validateForm()) {
          modalResult.closeModal = false;

          return of(modalResult);
        }

        let ob = of(null);
        if (this.adminUserTypeId == UserTypeAllItems.FlightSchool) {
          ob = this.getFlightSchoolOrganization(this.flightSchoolOrganizationId);
        }

        return ob.pipe(map((flightSchoolOrganization) => {
          modalResult.cancelled = false;
          modalResult.data = {
            userTypeMode: this.adminUserTypeId,
            flightSchoolOrganizationId: this.flightSchoolOrganizationId,
            flightSchoolId: flightSchoolOrganization?.FlightSchoolId
          };

          return modalResult;

        }));

      default:
        // Otherwise we're cancelling
        modalResult.cancelled = true;

        return of(modalResult);
    }
  }

  getFlightSchoolOrganization(flightSchoolOrganizationId?: number): Observable<FlightSchoolOrganizationEntity> {
    const query = AppMetaData.FlightSchoolOrganization.CreateQueryBuilder();
    query.addFilterAnd(f => f.Equal(a => a.FlightSchoolOrganizationId, flightSchoolOrganizationId));

    return this.ormDataService.executeQuerySingle(query);
  }

  validateForm() {
    return true;
  }


}
